module.exports = __webpack_public_path__ + "static/media/emojis2_27.e7b7d30a.svg";